import { render, staticRenderFns } from "./muscles-view.component.vue?vue&type=template&id=e0c3a594&scoped=true"
import script from "./muscles-view.component.ts?vue&type=script&lang=ts&external"
export * from "./muscles-view.component.ts?vue&type=script&lang=ts&external"
import style0 from "./muscles-view.component.scss?vue&type=style&index=0&id=e0c3a594&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c3a594",
  null
  
)

export default component.exports